// extracted by mini-css-extract-plugin
export var divider = "_u8-0";